import { render, staticRenderFns } from "./GlobalSportsCards.vue?vue&type=template&id=f588c56e&scoped=true"
import script from "./GlobalSportsCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSportsCards.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSportsCards.vue?vue&type=style&index=0&id=f588c56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f588c56e",
  null
  
)

export default component.exports